<div
  class="section-home-container"
  fxLayout="column"
  fxLayoutAlign="center center">

  <div
    class="search-container"
    fxLayoutAlign="center center">
    <form
      class="form-search"
      fxLayout="row">
      <mat-form-field
        class="form-control-search"
        [floatLabel]="'never'">
        <mat-icon
          class="search-icon"
          matPrefix
          color="accent">
          search
        </mat-icon>
        <!-- <mat-label>State</mat-label> -->
        <input
          matInput
          placeholder="{{tipoBusqueda==1?'Empecemos, ¿qué universidad estás buscando?':'Empecemos, ¿qué programa estás buscando?'}}"
          aria-label="State"
          [matAutocomplete]="auto"
          [formControl]="searchControl">

        <mat-autocomplete
          #auto="matAutocomplete"
          class="tuni-home-autocomplete"
          [displayWith]="displayFn"
          (optionSelected)="handleClickSelect($event)">
          <mat-option
            *ngIf="loading"
            class="is-loading">
            Buscando...
          </mat-option>
          <ng-container *ngIf="!loading">
            <mat-option
              *ngFor="let item of filteredStates"
              [value]="item">
              <ng-container *ngIf="tipoBusqueda==2">
                <span><b>{{item.nombreProgama}}</b></span>
              </ng-container>
              <ng-container *ngIf="tipoBusqueda==1">
                <span><b>{{item.nombre}}</b> ({{item.siglas}})</span>
              </ng-container>
            </mat-option>
          </ng-container>
        </mat-autocomplete>
      </mat-form-field>
      <button
        fxflex="none"
        class="search-button"
        mat-flat-button
        color="accent">
        Buscar
      </button>

    </form>
  </div>

  <div class="p-t-5 p-b-20">
    <mat-radio-group
      aria-label="Select an option"
      [(ngModel)]="tipoBusqueda"
      (ngModelChange)="handleChangeTipoBusqueda()">
      <mat-radio-button
        [value]="1"
        class="radio-button">
        Universidad
      </mat-radio-button>
      <mat-radio-button
        [value]="2"
        class="radio-button">
        Programa
      </mat-radio-button>
    </mat-radio-group>
  </div>

</div>
